import { Language } from '^/types';
import { L10nDictionary } from '^/utilities/l10n';
import * as T from '^/types';

export default {
  addCollaborators: {
    [Language.EN_US]: 'Add Collaborators',
    [Language.KO_KR]: '프로젝트 참여자 추가',
  },
  viewDetails: {
    [Language.EN_US]: 'View role details',
    [Language.KO_KR]: '역할 정보',
  },
  selectRole: {
    [Language.KO_KR]: '역할 선택',
    [Language.EN_US]: 'Select Role',
  },
  emailPlaceholder: {
    [Language.EN_US]: 'Email',
    [Language.KO_KR]: '이메일',
  },
  add: {
    [Language.EN_US]: 'Add',
    [Language.KO_KR]: '추가',
  },
  noCollaborators: {
    [Language.EN_US]: 'No collaborators',
    [Language.KO_KR]: '참여자가 없습니다',
  },
  invalidEmailError: {
    [Language.EN_US]: 'Invalid email address',
    [Language.KO_KR]: '유효하지 않은 이메일 주소',
  },
  existingEmailError: {
    [Language.EN_US]: 'Email already exists',
    [Language.KO_KR]: '이미 존재하는 이메일입니다',
  },
  multipleEmailsHelper: {
    [Language.EN_US]: 'Use commas (,) to enter multiple emails at once.',
    [Language.KO_KR]: '쉼표(,)를 사용하여 여러 개의 이메일을 한 번에 추가할 수 있습니다.',
  },
  infoText: {
    [Language.EN_US]: 'You can add & manage collaborators again after creating the project',
    [Language.KO_KR]: '프로젝트 생성 후에도 언제든 다시 참여자를 관리할 수 있습니다.',
  },
};

export const roleNames: { [key: string]: L10nDictionary } = {
  [T.PermissionRole.ADMIN]: {
    [T.Language.KO_KR]: '관리자',
    [T.Language.EN_US]: 'Admin',
  },
  [T.PermissionRole.MEMBER]: {
    [T.Language.KO_KR]: '멤버',
    [T.Language.EN_US]: 'Member',
  },
  [T.PermissionRole.VIEWER]: {
    [T.Language.KO_KR]: '뷰어',
    [T.Language.EN_US]: 'Viewer',
  },
  [T.PermissionRole.DEMO]: {
    [T.Language.KO_KR]: '데모',
    [T.Language.EN_US]: 'Demo',
  },
  [T.PermissionRole.PILOT]: {
    [T.Language.KO_KR]: '파일럿',
    [T.Language.EN_US]: 'Pilot',
  },
};

export const permissionNames: { [key: string]: L10nDictionary } = {
  view: {
    [Language.EN_US]: 'View',
    [Language.KO_KR]: '보기',
  },
  edit: {
    [Language.EN_US]: 'Edit',
    [Language.KO_KR]: '편집',
  },
  delete: {
    [Language.EN_US]: 'Delete',
    [Language.KO_KR]: '삭제',
  },
  upload: {
    [Language.EN_US]: 'Upload',
    [Language.KO_KR]: '업로드',
  },
  share: {
    [Language.EN_US]: 'Share',
    [Language.KO_KR]: '공유',
  },
};
